module.exports = __webpack_public_path__ + "static/media/f1rally-golden-gate.635a261a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1rally-golden-gate.jpg
// module id = 1639
// module chunks = 0